import { HttpClient, HttpParams, HttpHeaders, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

// Services
import { FilterService } from './baseListFilter.service';
import { SharedDataService } from './shared-data.service';


// Interfaces
import { Negotiation } from '../interfaces/negotiation';
import { Message } from '../interfaces/message';
import { Recipient } from '../interfaces/recipient'
import { Chain } from 'app/interfaces/chain';
import { Simulation } from '../interfaces/simulation';


@Injectable({
  providedIn: 'root'
})
export class NegotiationService extends FilterService {

  private errorMessage: Message;
  constructor(
    protected httpClient: HttpClient,
    protected sharedData: SharedDataService,
  ) {
    super()
    this.errorMessage = {
        status: 500
      , error: {errorMessage: 'Não Foi Possível Comunicar Com o Servidor!' }
      , ok: false
    }
    console.log('constructor > NegociationService')
  }

  getDataFiltered(params: HttpParams): Observable<HttpResponse<Negotiation[]>> {
    console.log("consoleParams", params)
    return this.httpClient.get<Negotiation[]>(`$companyId/tradeneg`, {observe: 'response', params})
  }
  getTradeBalance(params?: HttpParams): Observable<HttpResponse<any>> {

    return this.httpClient.get<any>(`$companyId/tradeBalance`, { observe: 'response', params });
  }
  loadNegotiationData( negotId: string): Observable<Negotiation> {
    const url = `$companyId/tradeneg/${negotId}`
    return this.handleGetRequest(url)
  }

  loadNegotiationSimulation(cnpj: string, negotiationId): Observable<Negotiation[]> {
    
    const url = negotiationId ? `$companyId/lktradeneg/${cnpj}/${negotiationId}` : `$companyId/lktradeneg/${cnpj}` 
    return this.handleGetRequest(url)
  }

  fetchRecipientData(queryRecipient): Observable<Recipient[]> {
    const params = this.handleParams([
      {
        cquery: queryRecipient,
        branchId: this.sharedData.getBranchId(),
        companyId: this.sharedData.getCompanyId(),
      }
    ])
    console.log(params)
    return this.handleGetRequestWithQueryParams('$companyId/lkrecipient', params)
  }

  fetchgrpOrcData(): Observable<any> {
    return this.httpClient.get<any>('$companyId/grpOrc')
  }

  fetchSellerData(): Observable<any> {
    return this.httpClient.get<any>('$companyId/lkseller')
  }

  // fetchChainData(queryChain): Observable<Chain[]> {
  //   const params = this.handleParams([
  //     {
  //       cquery: queryChain,
  //       branchId: this.sharedData.getBranchId(),
  //       companyId: this.sharedData.getCompanyId(),
  //     }
  //   ])
  //   return this.handleGetRequestWithQueryParams('$companyId/lkchain', params)
  // }

  saveNegotiation(data: Negotiation): Observable<Negotiation> {
    const url = '$companyId/tradeneg';
    const negotiation = new Subject<Negotiation>();

    this.httpClient.post<Negotiation>(url, data, {observe: 'response'}).subscribe(
      response => {
        this.httpClient.get<Negotiation>(response.headers.get('Location')).subscribe(
          simul => {
            console.log('simulation.service.saveNegotiation()', simul)
            negotiation.next(simul);
          }, error => {
            negotiation.error(error.status === 0 ? this.errorMessage : error)
          }
        )
      }, error => {
        negotiation.error(error.status === 0 ? this.errorMessage : error)
      }
    )
    return negotiation.asObservable();
  }

  handleDeleteNegotiation(negotID: String): Observable<Message> {
    const url = `$companyId/tradeneg/${negotID}`
    const message =  new Subject<Message>();
    this.httpClient.delete<Message>(url).subscribe(
      data => {
        message.next(data)
      }, error => {
        message.error(error.status === 0 ? this.errorMessage : error)
      }
    )
    return message.asObservable()
  }

  deleteNegotiation(negotID: String): Observable<Message> {
    const url = `$companyId/negociacao/${negotID}`
    const message =  new Subject<Message>();
    this.httpClient.delete<Message>(url).subscribe(
      data => {
        message.next(data)
      }, error => {
        message.error(error.status === 0 ? this.errorMessage : error)
      }
    )
    return message.asObservable()
  }

  sendToApproval(data: Negotiation): Promise<any> {
    const url = '$companyId/tradeneg/approval'
    return this.httpClient.post<Negotiation>(url, data, {observe: 'response'}).toPromise()
  }

  approveNegotiationTrade(data: Negotiation): Promise<any> {
    const url = '$companyId/tradeneg/approve'
    return this.httpClient.post<Negotiation>(url, data, {observe: 'response'}).toPromise()
  }

  repproveNegotiation(data: Negotiation): Promise<any> {
    const url = '$companyId/tradeneg/reprove'
    return this.httpClient.post<Negotiation>(url, data, {observe: 'response'}).toPromise()
  }

  handleParams(paramsFields) {
    let params = new HttpParams()
    paramsFields.map(field => {
      const key = Object.keys(field)[0]
      params = params.append(key, field[key])
    })
    return params
  }

  handleGetRequestWithQueryParams(url: string, params: HttpParams): Observable<any> {
    return this.httpClient.get<any>(url, {params})
  }

  handleGetRequest(url: string): Observable<any> {
    return this.httpClient.get<any>(url)
  }

  loadListNegotiation(params: HttpParams): Observable<HttpResponse<any>> {
    return this.httpClient.get<any>('$companyId/negociacao', { observe: 'response', params })
  }

  loadListRedes(params: HttpParams): Observable<HttpResponse<any>> {
    return this.httpClient.get<any>('$companyId/negociacao/pendente', { observe: 'response', params })
  }

  loadListSimul(codRede: string): Observable<HttpResponse<any>> {
    return this.httpClient.get<any>(`$companyId/negociacao/pendente/${codRede}`, { observe: 'response' })
  }

  generateNegotiation(body: any) {
    return this.httpClient.post<any>('$companyId/negociacao', body)
  }

  getSimulationsFromNegotiation(id: string, params: HttpParams): Observable<HttpResponse<any>> {
    return this.httpClient.get<any>(`$companyId/negociacao/${id}`, { observe: 'response', params })
  }

  approveNegotiation(body: any): Promise<any> {
    return this.httpClient.post<any>('$companyId/negociacao/approve', body, {observe: 'response'}).toPromise()
  }

  getTokenIPDV(body: any) {
    const url = '$third-party-api/https://api.ipdvgvc.com.br/api/gtex/getToken'
    return this.httpClient.post<any>(url, body).toPromise()
  }

  generateUrl(body: any) {
    const url = '$third-party-api/https://api.ipdvgvc.com.br/api/gtex/ssoLogin'
    return this.httpClient.post<any>(url, body).toPromise()
  }
}
